module.exports = __webpack_public_path__ + "img/assistant.b8a03067.png";